var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-tabs', {
    model: {
      value: _vm.activeTab,
      callback: function ($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('admin.tab.events')
    }
  }, [_c('admin-event-table')], 1), _c('b-tab', {
    attrs: {
      "title": _vm.$t('admin.tab.users')
    }
  }, [_c('admin-user-table')], 1), _c('b-tab', {
    attrs: {
      "title": _vm.$t('admin.tab.documents')
    }
  }, [_c('admin-documents')], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }